import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";

const initialState = {
  cartItems: [],
};

const cal_total = (state) => {
  for (let index = 0; index < state.cartItems.length; index++) {
    if (state.cartItems[index].supplement?.farecode_price)
      state.cartItems[index].subtotal =
        state.cartItems[index].adults.reduce(
          (acc, item) => acc + item.quantity,
          0
        ) * state.cartItems[index].supplement?.farecode_price;
    if (state.cartItems[index].supplement?.child?.farecode_price) {
      state.cartItems[index].subtotal +=
        state.cartItems[index].children.reduce(
          (acc, item) => acc + item.quantity,
          0
        ) * state.cartItems[index].supplement.child.farecode_price;
    }
    if (state.cartItems[index].stateroom) {
      state.cartItems[index].subtotal =
        state.cartItems[index].stateroom.diff_price;
    }
  }
  state.total = state.cartItems.reduce((acc, item) => {
    return acc + item.subtotal;
  }, 0);
};

const handleToastClick = {
  onClick: () => {
    window.location.href = process.env.PUBLIC_URL + "/cart";
  },
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addItem: (state, action) => {
      if (action.payload.supplement) {
        const index = state.cartItems.findIndex(
          (item) => item.supplement?.title === action.payload.supplement?.title
        );
        if (index === -1) {
          state.cartItems.push(action.payload);
          toast.success("Item added to cart", handleToastClick);
        } else {
          state.cartItems[index] = action.payload;
          toast.info("Item updated in cart", handleToastClick);
        }
      } else {
        const index = state.cartItems.findIndex(
          (item) =>
            item.prev_cabin?.room_id === action.payload.prev_cabin?.room_id
        );
        if (index !== -1) {
          state.cartItems[index] = action.payload;
          toast.info("Item updated in cart", handleToastClick);
        } else {
          state.cartItems.push(action.payload);
          toast.success("Item added to cart", handleToastClick);
        }
      }
      cal_total(state);
    },
    removeItem: (state, action) => {
      if (action.payload.type === "supplement") {
        state.cartItems = state.cartItems.filter(
          (item) => item.supplement?.title !== action.payload.title
        );
      } else if (action.payload.type === "stateroom") {
        state.cartItems = state.cartItems.filter(
          (item) => item.prev_cabin?.room_id !== action.payload.title
        );
      }
      toast.info("Item removed from cart");
      cal_total(state);
    },
    updateItem: (state, action) => {
      const { title, type, action: act } = action.payload;
      const index = state.cartItems.findIndex(
        (item) => item.supplement?.title === title
      );
      if (act === "increment") {
        state.cartItems[index][type] += 1;
      } else if (act === "decrement") {
        state.cartItems[index][type] -= 1;
      }
      cal_total(state, index);
    },
    clearCart: (state) => {
      state.cartItems = [];
    },
  },
});

export const { addItem, removeItem, updateItem, clearCart } = cartSlice.actions;
export default cartSlice.reducer;
